import { Component, OnInit } from '@angular/core';
import { AuthService} from '../../services/auth.service';

declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}
export const ROUTES: RouteInfo[] = [
  { path: 'home', title: 'Úvodní strana',  icon: 'fa fa-home', class: '' },
  { path: 'notes', title: 'Poznámky',  icon:'fa fa-sticky-note-o', class: '' },
  { path: 'lists', title: 'Seznamy',  icon: 'fa fa-list-alt', class: '' },
  { path: 'projects', title: 'Projekty',  icon: 'fa fa-flask', class: '' },
  { path: 'contacts', title: 'Kontakty',  icon:'fa fa-address-book-o', class: '' },
  { path: 'wall', title: 'Zeď',  icon:'fa fa-question', class: '' },
  { path: 'routine', title: 'Rutiny',  icon:'fa fa-history', class: '' },
  { path: 'deleted', title: 'Koš',  icon:'fa fa-trash-o', class: '' }
];

export const ROUTESNAV: RouteInfo[] = [
  { path: 'user', title: 'Můj účet',  icon:'fa fa-user-o', class: '' }
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];
  menuNavItems: any[];

  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);
    this.menuNavItems = ROUTESNAV.filter(menuNavItem => menuNavItem);

  }

}



// WEBPACK FOOTER //
// ./src/app/components/sidebar/sidebar.component.ts